import { API } from 'aws-amplify';
import { getAuthHeaders } from './auth';

type MaintenanceBannerResponse = {
    data?: {
        html?: string;
    };
};

const getMaintenanceBanner = async (): Promise<string> => {
    try {
        const response = (await API.get('membership', '/maintenance-banner', {
            headers: getAuthHeaders(),
        })) as MaintenanceBannerResponse;
        return response?.data?.html || '';
    } catch (_error) {
        return '';
    }
};

export default getMaintenanceBanner;